import styled from 'styled-components';

import { VerticalCenterBlock } from '../../../../styled';

export const TextWrapper = styled(VerticalCenterBlock)`
  gap: 8px;
`;
